import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=08579cfe&"
import script from "./ExpandableText.vue?vue&type=script&lang=ts&"
export * from "./ExpandableText.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports